var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"line_wrap"},[_c('canvas',{attrs:{"id":_vm.chartName,"width":"500","height":"250"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }